import { addMinutes } from "date-fns";
import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

type ExtendedEndTimeParams = {
  /** Schedule end as returned by the API: a wall clock with a literal `Z`. */
  end: string;
  /** Zone that wall clock belongs to (`schedule.time_zone`). */
  timeZone: string;
  /** Zone the reservation is shown in — the office zone when we know it. */
  displayTimeZone: string;
  minutes: number;
};

/**
 * The API stamps schedule times with a literal `Z` no matter which zone they were
 * rendered in, and reports that zone in `time_zone`: `UTC` for the agenda endpoint
 * (which the dashboard and the Teams/Outlook add-in read), the office zone for
 * `/schedules`. Resolving the wall clock through `time_zone` before formatting it
 * in the office zone keeps the preview in sync with the reservation card — reading
 * the `Z` at face value showed an agenda reservation in UTC (sc-8954).
 */
export function formatExtendedEndTime({
  end,
  timeZone,
  displayTimeZone,
  minutes
}: ExtendedEndTimeParams): string {
  const currentEnd = fromZonedTime(end.replace("Z", ""), timeZone);
  return formatInTimeZone(
    addMinutes(currentEnd, minutes),
    displayTimeZone,
    "h:mm a"
  );
}
